import React, { Component } from "react";
import {Button, ListGroup, ListGroupItem} from "reactstrap";
import ChatMessage from "./components/ChatMessage"
import ChatInput from "./components/ChatInput"
import "./Chat.scss";
var io = require("socket.io-client");

const botServer = `${process.env.REACT_APP_DIALOG_MANAGER}/dashchat`;
const socketPath = process.env.REACT_APP_DASH_SOCKET_PATH || "/dm/dashchat_socket.io";

const chat = {
  display: "flex",
  flexFlow: "column",
  height: "100%"
}

const chatHeader = {
  textAlign: "center",
  flex: "0 1 46px",
  borderBottom: "1px solid #C8CED3"
}

const  chatContent = {
  flex: "1",
  overflow: 'auto'
}

export default class Chat extends Component {
  constructor() {
    super();
    this.sendMessage = this.sendMessage.bind(this)
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.startConversation = this.startConversation.bind(this);
    this.restartConversation = this.restartConversation.bind(this);
    this.sendGreeting = this.sendGreeting.bind(this);
    this.state = {
      socketId: null,
      conversationId: null,
      messages: []
    }
  };

  componentDidUpdate(){
    this.scrollToBottom()
  }

  startConversation(reset){
    if(typeof this.client === "undefined" || reset){
      /*
        query:'b64=1' required for parsing binary parameters
        https://github.com/miguelgrinberg/Flask-SocketIO/issues/771
      */

      this.client = io(botServer, { 
        query: "b64=1", 
        forceNew: true, 
        path: socketPath,
        transports: ['websocket']
      });
      
      this.client.on("connect", () => {
        const socketId = this.client.id.indexOf("#") > -1 && this.client.id.split("#")[1];

        this.setState({
          socketId: socketId
        });
      });

      this.client.on("identify", message => {
        if(!this.state.conversationId){
          this.setState({
            conversationId: message
          });
          this.sendGreeting();
          this.greeted = true;
        }
      });
  
      this.client.on("bot_uttered", message => {
        this.receivedResponse(message.text, message.attachment, message.triggers);
        this.arr = message.quick_replies;
  
        if (typeof this.arr !== "undefined" && this.arr.length > 0) {
          var sugList = [];
          for (let i = 0; i < this.arr.length; i++) {
            if (this.arr[i].content_type === "text")
              sugList.push(this.arr[i].title);
          }
          this.setState({
            suggestions: sugList
          });
        } else {
          this.setState({
            suggestions: []
          });
        }
      });
    }
  }

  sendGreeting(){
    if(this.client){
      var greetingPayload = `/greet{"channelUserId": "${this.state.socketId}"}`;
      this.client.emit("user_uttered", { message: greetingPayload, sender: this.state.conversationId, customData: {} });
    }
  }

  sendMessage(messageText) {
    var newMessage = {
      isSender: true,
      text: this.state.redactInput ?  this.redactMessage(messageText) : messageText
    }

    this.submitResponse(messageText)

    this.state.messages.push(newMessage);

    this.setState({
      messages: this.state.messages
    });

    this.scrollToBottom()
  }

  async submitResponse(text) {
    this.client.emit("user_uttered", { message: text, sender: this.state.conversationId, customData: {} });
  }

  scrollToBottom(){
    var chatWindow = document.getElementById("chatWindow");

    if(chatWindow){
      chatWindow.scrollTop = chatWindow.scrollHeight
    }    
  }

  redactMessage(message){
    return message.replace(/./gi, "*")
  }

  restartConversation(){
    this.setState({
      conversationId: null,
      messages: []
    });

    this.startConversation(true);

  }

  receivedResponse(text, attachment, triggers){

    if (typeof text !== "undefined" /*&& !text.includes("In the real world")*/){
      this.state.messages.push({ text: text, isSender: false, url: null });
    } 

    if (typeof attachment !== "undefined" && attachment.type === "image") {
      var reach =
        "http://dplai01.vail:5005" +
        "/webhooks/webchat/webhook/" +
        attachment.payload.src;
      //var reach = "https://random-d.uk/api/v1/gifs/23.gif" //test with gif
      //var reach = "https://fakeimg.pl/750x500/?text=Hello" //test with bigger image
      this.state.messages.push({ text: "", isSender: false, url: reach });
    }

    this.setState({
      messages: this.state.messages,
      redactInput: triggers && triggers.redact
    })
  }

  render() {
    return (
      <div style={chat}>
        <div style={chatHeader}>
          <Button className="btn-sm btn-pill m-2" onClick={this.restartConversation}>
            <i className="icon-refresh icons font-sm"/>
          </Button>
        </div>
        <div style={chatContent}>
          <ListGroup id="chatWindow" className="chat-window">
            {this.state.messages.map( (message, index) => {
              return <ListGroupItem className="border-none" key={index}>
                <ChatMessage message={message}></ChatMessage>
              </ListGroupItem>
            })}
          </ListGroup>
        </div>
        <ChatInput sendMessage={this.sendMessage} startConversation={this.startConversation} conversationStarted={this.state.conversationId} redactInput={this.state.redactInput}></ChatInput>
      </div>
    );
  }
}